// extracted by mini-css-extract-plugin
export default {"container":"online-tag_container__-h758"};